import YouTube, { YouTubeProps } from 'react-youtube'

export const SimpleYoutube = ({ videoId }: { videoId: string }) => {
  const opts: YouTubeProps['opts'] = {
    width: '100%',
  }

  return <YouTube videoId={videoId} opts={opts} />
}
